import { render, staticRenderFns } from "./workshop-transfer.vue?vue&type=template&id=12a8c946&scoped=true&"
import script from "./workshop-transfer.vue?vue&type=script&lang=js&"
export * from "./workshop-transfer.vue?vue&type=script&lang=js&"
import style0 from "./workshop-transfer.vue?vue&type=style&index=0&id=12a8c946&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a8c946",
  null
  
)

export default component.exports